import { render } from "./ProfilePage.vue?vue&type=template&id=5efa51d6&ts=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"

import "./ProfilePage.vue?vue&type=style&index=0&id=5efa51d6&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__